import { render, staticRenderFns } from "./AutoTranslate.html?vue&type=template&id=4cd00574&external"
import script from "./AutoTranslate.ts?vue&type=script&lang=ts&external"
export * from "./AutoTranslate.ts?vue&type=script&lang=ts&external"
import style0 from "./AutoTranslate.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports